export class SecurityScanNotificationData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "justification",
            "baseName": "justification",
            "type": "string",
            "format": ""
        },
        {
            "name": "confidenceScore",
            "baseName": "confidenceScore",
            "type": "number",
            "format": "float"
        },
        {
            "name": "detectorType",
            "baseName": "detectorType",
            "type": "SecurityScanNotificationDataDetectorTypeEnum",
            "format": ""
        },
        {
            "name": "conclusion",
            "baseName": "conclusion",
            "type": "SecurityScanNotificationDataConclusionEnum",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SecurityScanNotificationData.attributeTypeMap;
    }
    constructor() {
    }
}
export var SecurityScanNotificationDataDetectorTypeEnum;
(function (SecurityScanNotificationDataDetectorTypeEnum) {
    SecurityScanNotificationDataDetectorTypeEnum["Malware"] = "MALWARE";
    SecurityScanNotificationDataDetectorTypeEnum["RansomwareBehavior"] = "RANSOMWARE_BEHAVIOR";
    SecurityScanNotificationDataDetectorTypeEnum["DataAnomaly"] = "DATA_ANOMALY";
})(SecurityScanNotificationDataDetectorTypeEnum || (SecurityScanNotificationDataDetectorTypeEnum = {}));
export var SecurityScanNotificationDataConclusionEnum;
(function (SecurityScanNotificationDataConclusionEnum) {
    SecurityScanNotificationDataConclusionEnum["Clean"] = "CLEAN";
    SecurityScanNotificationDataConclusionEnum["HighChanceForRansomware"] = "HIGH_CHANCE_FOR_RANSOMWARE";
    SecurityScanNotificationDataConclusionEnum["DataAnomalyDetected"] = "DATA_ANOMALY_DETECTED";
    SecurityScanNotificationDataConclusionEnum["MalwareDetected"] = "MALWARE_DETECTED";
})(SecurityScanNotificationDataConclusionEnum || (SecurityScanNotificationDataConclusionEnum = {}));
